import { FreeSpinsInfoEvent, SpinResponse } from '@cgs/data-access';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from '../states/base_game_state';
import { ResumeRule } from './infra/resume_rule';

export class StopToBeginFreeSpins<TResponse extends SpinResponse> extends ResumeRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  ruleCondition(resp: ResponseHolder<TResponse>): boolean {
    return (
      !resp.curResponse.isBonus &&
      !resp.curResponse.isScatter &&
      !!resp.curResponse.freeSpinsInfo &&
      (resp.curResponse.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsStarted ||
        resp.curResponse.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsAdded) &&
      (resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
        FreeSpinsInfoEvent.FreeFreeSpinsGroupName ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
          FreeSpinsInfoEvent.PurchasedFreeSpinsGroupName)
    );
  }
}
